// import { useState } from "react";
// import logo from "../../assets/logo-hubsyntax.png";

// export default function PricingPlan() {
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const [activeIndex, setActiveIndex] = useState(null);

//   const plans = [
//     {
//       title: "15-hour Pack",
//       price: "$405",
//       subPrice:"$27",
//       features: ["Consistent Shopify Support", "Experienced Shopify Developers", "Custom Shopify store setup"],
//       amount: 405, 
//     },
//     {
//       title: "30-hour pack",
//       price: "$750",
//       subPrice:"$25",
//       features: [
//         "Long-term Commitment", "Advanced Shopify store setup", "Dedicated Project Management",
//       ],
//       amount: 750,
//     },
//     {
//       title: "Price per Hour",
//       price: "$30",
//       subPrice:'',
//       features: [
//         "Covers all Shopify development Aspects", "On-Demand Support", "Quick fixes and minor updates",
//       ],
//       amount: 30,
//     },
//   ];

//   const handleClick = (index) => {
//     setActiveIndex(index);
//     setTimeout(() => {
//       setActiveIndex(null);
//     }, 0);
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleBuyClick = async (plan) => {
//     const res = await loadRazorpayScript();
//     if (!res) {
//       alert("Failed to load Razorpay SDK. Are you online?");
//       return;
//     }

//     const options = {
//       key: "rzp_test_FVKP760wYjv9Hm", 
//       amount: plan.amount * 100,
//       currency: "USD",
//       name: 'HubSyntax',
//       description: "Payment for " + plan.title,
//       image:logo, 
//       handler: function (response) {
//         alert("Payment ID: " + response.razorpay_payment_id);
//       },
//       prefill: {
//         email: "anderwjackson15@gmail.com",
//         contact: "+14316311194",
//       },
//       theme: {
//         color: "#3399cc",
//       },
//       modal: {
//         ondismiss: function () {
//           if (window.confirm("Are you sure, you want to close the form?")) {
//             console.log("Checkout form closed by the user");
//           } else {
//             console.log("Complete the Payment");
//           }
//         }
//       }
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };

//   return (
//     <section className="pricing-plan-wrp">
//       <div className="container">
//         <div className="banner-wrapper">
//           <div className="pricing-plan-hr">
//             {plans.map((plan, index) => (
//               <div
//                 key={index}
//                 className={`pricing-plan-wraping ${hoveredIndex !== null
//                     ? hoveredIndex === index
//                       ? "active"
//                       : ""
//                     : activeIndex !== null
//                       ? activeIndex === index
//                         ? "active"
//                         : ""
//                       : index === 1
//                         ? "active"
//                         : ""
//                   }`}
//                 onMouseEnter={() => setHoveredIndex(index)}
//                 onMouseLeave={() => setHoveredIndex(null)}
//                 onClick={() => handleClick(index)}
//               >
//                 <div className="pricing-plan-section-bannr">
//                   <h4>{plan.title}</h4>
//                   <h4 className="pricing-plan-num">
//                     {plan.price} <span>{plan.subPrice}/ Hour</span>
//                   </h4>
//                   <span
//                     className="pricing-plan-btn"
//                     onClick={(e) => {
//                       e.stopPropagation(); 
//                       handleBuyClick(plan);
//                     }}
//                   >
//                     Buy
//                   </span>
//                   <div className="pricing-pla-rating">
//                     <div className="star-icon"></div>
//                     <p>Guaranteed ROI</p>
//                   </div>
//                 </div>
//                 <div className="pricing-plan-feature">
//                   <p>Features</p>
//                   {plan.features.map((feature, i) => (
//                     <div className="pricing-plan-feature-steps" key={i}>
//                       <div className="sign-icon"></div>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
 
import { useState } from "react";
import logo from "../../assets/logo-hubsyntax.png";

export default function PricingPlan() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const plans = [
    {
      title: "15-hour Pack",
      priceUSD: 405,
      subPriceUSD: 27,
      features: [
        "Consistent Shopify Support",
        "Experienced Shopify Developers",
        "Custom Shopify store setup",
      ],
    },
    {
      title: "30-hour pack",
      priceUSD: 750,
      subPriceUSD: 25,
      features: [
        "Long-term Commitment",
        "Advanced Shopify store setup",
        "Dedicated Project Management",
      ],
    },
    {
      title: "Price per Hour",
      priceUSD: 30,
      subPriceUSD: 0,
      features: [
        "Covers all Shopify development Aspects",
        "On-Demand Support",
        "Quick fixes and minor updates",
      ],
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(index);
    setTimeout(() => {
      setActiveIndex(null);
    }, 0);
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleBuyClick = async (plan) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Failed to load Razorpay SDK. Are you online?");
      return;
    }

    const options = {
      key: "rzp_test_FVKP760wYjv9Hm", 
      amount: plan.priceUSD * 100,
      currency: "USD",
      name: "HubSyntax",
      description: "Payment for " + plan.title,
      image: logo,
      handler: function (response) {
        alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
      },
      prefill: {
        email: "anderwjackson15@gmail.com",
        contact: "+14316311194",
      },
      theme: {
        color: "#3399cc",
      },
      modal: {
        ondismiss: function () {
          if (window.confirm("Are you sure you want to close the form?")) {
            console.log("Checkout form closed by the user");
          } else {
            console.log("Complete the Payment");
          }
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <section className="pricing-plan-wrp">
      <div className="container">
        <div className="banner-wrapper">
          <div className="pricing-plan-hr">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`pricing-plan-wraping ${
                  hoveredIndex !== null
                    ? hoveredIndex === index
                      ? "active"
                      : ""
                    : activeIndex !== null
                    ? activeIndex === index
                      ? "active"
                      : ""
                    : index === 1
                    ? "active"
                    : ""
                }`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => handleClick(index)}
              >
                <div className="pricing-plan-section-bannr">
                  <h4>{plan.title}</h4>
                  <h4 className="pricing-plan-num">
                    ${plan.priceUSD}{" "}
                    {plan.subPriceUSD ? <span>${plan.subPriceUSD}/ Hour</span> : null}
                  </h4>
                  <span
                    className="pricing-plan-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBuyClick(plan);
                    }}
                  >
                    Buy
                  </span>
                  <div className="pricing-pla-rating">
                    <div className="star-icon"></div>
                    <p>Guaranteed ROI</p>
                  </div>
                </div>
                <div className="pricing-plan-feature">
                  <p>Features</p>
                  {plan.features.map((feature, i) => (
                    <div className="pricing-plan-feature-steps" key={i}>
                      <div className="sign-icon"></div>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
